<div class="card">
  <h3 class="card__title card__title--left">Patch Details</h3>
  <div class="tablewrap">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="computer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Computer</th>
        <td mat-cell *matCellDef="let p" class="mono">{{ p.computer }}</td>
      </ng-container>

      <ng-container matColumnDef="kbNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>KB Number</th>
        <td mat-cell *matCellDef="let p" class="mono">{{ p.kbNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="severity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Severity</th>
        <td mat-cell *matCellDef="let p">
          <span class="sev" [ngClass]="'sev--' + sevClass(p.severity)"><i></i>{{ p.severity }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="installStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Install Status</th>
        <td mat-cell *matCellDef="let p">
          <span class="pill-status" [class.is-missing]="p.installStatus === 'Missing'">{{ p.installStatus }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="deploymentStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Deployment Status</th>
        <td mat-cell *matCellDef="let p" [ngSwitch]="p.deploymentStatus">
          <span *ngSwitchCase="'Reboot Pending'" class="dep dep--reboot"><i></i>Reboot Pending</span>
          <span *ngSwitchCase="'Failed'" class="dep dep--failed"><i></i>Failed</span>
          <span *ngSwitchCase="'Installed'" class="dep dep--installed"><i></i>Installed</span>
          <span *ngSwitchCase="'Delay in Deployment'" class="dep dep--delay"><i></i>Delay in Deployment</span>
          <span *ngSwitchCase="'Unknown'" class="dep dep--unknown"><i></i>Unknown</span>
          <span *ngSwitchDefault class="dep dep--none">&mdash;</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="patchName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Patch Name</th>
        <td mat-cell *matCellDef="let p" class="summary-cell">{{ p.patchName }}</td>
      </ng-container>

      <ng-container matColumnDef="patchType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Patch Type</th>
        <td mat-cell *matCellDef="let p">{{ p.patchType }}</td>
      </ng-container>

      <ng-container matColumnDef="os">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>OS</th>
        <td mat-cell *matCellDef="let p">{{ p.os }}</td>
      </ng-container>

      <ng-container matColumnDef="releaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Release Date</th>
        <td mat-cell *matCellDef="let p" class="mono">{{ p.releaseDate }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div class="empty-state">
            <mat-icon>info_outline</mat-icon>
            <span>No Patch Data</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[10, 25, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>
